import React from 'react';
import HeroSection from './hero-section'
import CallSection from '../call-section'
import DescriptionSection from './description'
import ForUs from './for-us'
import EducationalResources from './educational-resources'
import PartnerOrg from './partner-org'
import OnGoingCommunity from './ongoing-community'
import JoinCommunity from './join-community'
const Community = () => {
  return (
    <>
      <HeroSection />
      <CallSection />
      <DescriptionSection/>
      <ForUs/>
      <EducationalResources/>
      <PartnerOrg/>
      <OnGoingCommunity />
      <JoinCommunity/>
    </>
  );
};

export default Community;
